import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Bootstrap
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// Helpers de formulário

class TabStaffsTrainingTab extends Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      'dados': [],
      'dados_modal_materias': [],
      'titulo_modal_treinamento': [],
      'modal': false,
    };
    this.showModal = this.showModal.bind(this);
    this.botaoAcoes = this.botaoAcoes.bind(this);
    this.export = this.export.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.treinamentos)) {
      this.setState({dados: newProps.treinamentos});
    }
  }

  showModal(event) {
    var target = event.currentTarget.value;
    var url = config.get('api') + '/alunos/treinamento/titulo/'+target;
    var url_materias = config.get('api') + '/alunos/treinamentos_finalizados/'+target;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({titulo_modal_treinamento: responseJson.data,});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
    Promise.resolve(header).then(function(value) {
      fetch(url_materias, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({dados_modal_materias: responseJson.data, modal: true});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoAcoes (cell, row) {
    if (row.status === "Aprovado") {
      var botao = (
        <div className="btn-group">
          <button className="btn btn-info btn-sm" value={cell} onClick={this.showModal}>
              <i className="fa fa-fw fa-eye"></i>
          </button>
          <button className="btn btn-success btn-sm" value={cell} onClick={this.export}><i className="fa fa-fw fa-download"></i></button>
        </div>
      );
      
    } else {
      var botao = (
        <div className="btn-group">
          <button className="btn btn-info btn-sm" value={cell} onClick={this.showModal}>
              <i className="fa fa-fw fa-eye"></i>
          </button>
          <button className="btn btn-warning btn-sm" disabled="disabled" value={cell} onClick={this.export}><i className="fa fa-fw fa-download"></i></button>
        </div>
      );      
    }

    return botao;
  }

  export(event) {
    var team_id = event.currentTarget.value;
    var url = "/exportar/certificado/aluno/" + team_id;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }

  botaoName (cell, row) {
    var url = '/turma/editar/' + row.turma_id;
    var botao = (
      <Link to={url}>
        <strong>{row.turma_nome}</strong>
      </Link>
    );

    return botao;
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Treinamentos</h3>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há treinamentos realizados para este aluno'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="treinamento_nome" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>

    <TableHeaderColumn dataField="turma_nome" dataFormat={this.botaoName} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='280'>Turma</TableHeaderColumn>

    <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>

    <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

    <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Final</TableHeaderColumn>

    <TableHeaderColumn dataField="url_modal_materias" dataAlign="center" dataFormat={this.botaoAcoes} width='120'>Ações</TableHeaderColumn>

  </BootstrapTable>

  <Modal show={this.state.modal} bsSize="large" aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
        <h4 className="pull-left">Matérias - {this.state.titulo_modal_treinamento.turma_nome + " - " + this.state.titulo_modal_treinamento.treinamento_nome}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <BootstrapTable data={this.state.dados_modal_materias} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn isKey={true} dataField="materia_nome" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matéria</TableHeaderColumn>

        <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>

        <TableHeaderColumn dataField="result" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Resultado</TableHeaderColumn>

        <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

        <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Final</TableHeaderColumn>
      </BootstrapTable>
    </Modal.Body>
    <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
        <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default TabStaffsTrainingTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/TabStaffsTrainingTab.js